export default __webpack_public_path__ + "media/images/mailer/icon_cached-d6eddd4eb137566292aeac1fb5985386.png";